var map = {
	"./administer.svg": "y4bj",
	"./agency.svg": "B+VF",
	"./api.svg": "Mz/u",
	"./arrow.svg": "wMN8",
	"./batch.svg": "C0FN",
	"./cancel.svg": "0P6P",
	"./card-data.svg": "jEzI",
	"./card-password.svg": "6xTX",
	"./card.svg": "nFXC",
	"./commodity.svg": "qTTu",
	"./configuration.svg": "gwI0",
	"./data.svg": "a0bE",
	"./error.svg": "FHKZ",
	"./explain-icon.svg": "8JAs",
	"./export.svg": "DaNX",
	"./form.svg": "HbpF",
	"./home.svg": "GU1v",
	"./information.svg": "5Rxl",
	"./link.svg": "kKPj",
	"./material.svg": "0MDs",
	"./me-password.svg": "HgDJ",
	"./me.svg": "TJvx",
	"./money.svg": "IF5j",
	"./operation.svg": "KFNc",
	"./order.svg": "yFCU",
	"./parameter.svg": "htBy",
	"./pass.svg": "5FdV",
	"./pay.svg": "Wzs1",
	"./payment.svg": "3V4M",
	"./phone.svg": "bDN7",
	"./provide.svg": "Dqsq",
	"./record.svg": "q1X2",
	"./refund.svg": "ygRL",
	"./register.svg": "tk39",
	"./relevance.svg": "QAe4",
	"./remind.svg": "azJ5",
	"./role.svg": "sxzF",
	"./route-filter.svg": "jLIj",
	"./running.svg": "D4YU",
	"./search-head.svg": "vNv4",
	"./search.svg": "EqOI",
	"./setting.svg": "av6B",
	"./stock-config.svg": "K+n/",
	"./supplier.svg": "+c8Z",
	"./supply.svg": "U10B",
	"./sys-base.svg": "Oe3d",
	"./task.svg": "ebys",
	"./telephone.svg": "T5Ms",
	"./transaction.svg": "oP+6",
	"./transfer.svg": "IjL1",
	"./type.svg": "w2i3",
	"./user.svg": "EOg8",
	"./userL.svg": "kQ3N",
	"./vip.svg": "x9ib",
	"./warehouse.svg": "HzdX",
	"./withdraw.svg": "kGe1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 7